<template>
    <v-card :loading="loading" flat class="gi-card mb-4">
        <button type="button" class="gi-head" :aria-expanded="isExpanded ? 'true' : 'false'" @click="isExpanded = !isExpanded">
            <span class="gi-ic"><v-icon small>mdi-source-branch</v-icon></span>
            <div class="gi-title-wrap">
                <span class="gi-eyebrow">{{ $t('ProcessTitle') }}</span>
                <span class="gi-title">{{ processInfo.processTitle || '—' }}</span>
            </div>
            <span class="gi-chip" v-if="processInfo.referenceNumber">{{ processInfo.referenceNumber }}</span>
            <v-icon class="gi-chev" :class="{ 'is-open': isExpanded }">mdi-chevron-down</v-icon>
        </button>

        <v-expand-transition>
            <div v-show="isExpanded" class="gi-body">
                <div class="gi-grid">
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('ProcessNumber') }}</span>
                        <span class="gi-val">{{ processInfo.processNumber || '—' }}</span>
                    </div>
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('ReferenceNumber') }}</span>
                        <span class="gi-val">{{ processInfo.referenceNumber || '—' }}</span>
                    </div>
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('Status') }}</span>
                        <span class="gi-val"><span class="gi-status">{{ processInfo.status ? $t(processInfo.status) : '—' }}</span></span>
                    </div>
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('CreatedDate') }}</span>
                        <span class="gi-val">{{ processInfo.createdDate | formatDateTimeGregorian }}</span>
                    </div>
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('Stage') }}</span>
                        <span class="gi-val">{{ processInfo.stage ? $t(processInfo.stage) : '—' }}</span>
                    </div>
                    <div class="gi-fact">
                        <span class="gi-lbl">{{ $t('ProcessType') }}</span>
                        <span class="gi-val">{{ processInfo.processType || '—' }}</span>
                    </div>
                </div>
            </div>
        </v-expand-transition>
    </v-card>
</template>
<script>
    import TasksService from '@/services/TasksService.js'

    export default {

        props: {
            taskId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                loading: false,
                isExpanded: false,
                processInfo: {
                    processTitle: null,
                    processNumber: null,
                    referenceNumber: null,
                    status: null,
                    createdDate: null,
                    stage: null,
                    processType: null,
                }
            }
        },

        created() {
            this.getProcessInfo()
        },

        methods: {

            getProcessInfo() {

                this.loading = true

                TasksService.getProcessInfo(this.taskId)
                    .then(response => {
                        this.processInfo = response.data
                    })
                    .catch(() => {

                    }).finally(() => {
                        this.loading = false
                    })
            }
        }
    }
</script>
<style scoped>
    .gi-card {
        --gi-surface: #f3f6f5;
        --gi-line: #e6ecea;
        --gi-text: #1f2a28;
        --gi-muted: #6b7a77;
        --gi-primary: #0a716e;
        --gi-primary-tint: #e6f2f1;
        border: 1px solid #e6ecea !important;
        border-radius: 18px !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, .04), 0 8px 24px -16px rgba(15, 23, 42, .18) !important;
        overflow: hidden;
    }

    .gi-head {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        padding: 14px 18px;
        border: 0;
        background: transparent;
        text-align: start;
        font: inherit;
        color: var(--gi-text);
        cursor: pointer;
        transition: background-color .2s;
    }
    .gi-head:hover { background: #f8faf9; }
    .gi-head:focus { outline: none; }
    .gi-head:focus-visible { box-shadow: inset 0 0 0 2px var(--gi-primary); }

    .gi-ic {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 34px;
        width: 34px;
        height: 34px;
        border-radius: 11px;
        background: var(--gi-primary-tint);
    }
    .gi-ic .v-icon { color: var(--gi-primary) !important; }

    .gi-title-wrap { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; }
    .gi-eyebrow { font-size: 11.5px; font-weight: 600; color: var(--gi-muted); }
    .gi-title { font-size: 14.5px; font-weight: 700; line-height: 1.45; color: var(--gi-text); }

    .gi-chip {
        flex: 0 0 auto;
        font-size: 11.5px;
        font-weight: 700;
        color: var(--gi-primary);
        background: var(--gi-primary-tint);
        padding: 3px 10px;
        border-radius: 999px;
    }

    .gi-chev {
        flex: 0 0 auto;
        color: var(--gi-muted) !important;
        transition: transform .25s cubic-bezier(.2, .8, .2, 1);
    }
    .gi-chev.is-open { transform: rotate(180deg); }

    .gi-body { border-top: 1px solid var(--gi-line); }

    .gi-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
        padding: 12px;
    }

    .gi-fact {
        display: flex;
        flex-direction: column;
        gap: 3px;
        padding: 10px 12px;
        border-radius: 12px;
        background: var(--gi-surface);
        min-width: 0;
    }
    .gi-lbl { font-size: 11px; font-weight: 600; color: var(--gi-muted); }
    .gi-val { font-size: 13px; font-weight: 700; color: var(--gi-text); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .gi-status {
        display: inline-block;
        padding: 1px 9px;
        border-radius: 999px;
        background: var(--gi-primary-tint);
        color: var(--gi-primary);
        font-size: 12px;
    }

    @media (max-width: 960px) {
        .gi-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    }
    @media (max-width: 600px) {
        .gi-grid { grid-template-columns: 1fr; }
    }
    @media (prefers-reduced-motion: reduce) {
        .gi-chev, .gi-head { transition: none; }
    }
</style>
